
import { Theme, makeStyles } from '@material-ui/core';

export const valueTextStyle = (theme: Theme) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
});

export const useBulkActionStyles = makeStyles((theme) => ({
  inlineButtonContainer: {
    display: 'inline-flex',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  stackedButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
  button: {
    marginBottom: 0,
    marginRight: 0,
  },
  confirmText: {
    fontSize: '0.99rem',
    padding: theme.spacing(1, 0),
    color: theme.palette.text.secondary,
  },
}));
